import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Cards {
  constructor() {
    this.elements = document.querySelectorAll('.js-card');

    if (!this.elements.length) {
      return false;
    }

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    ScrollTrigger.defaults({
      markers: false,
    });

    for (let i = 0; i < this.elements.length; i++) {
      const element = this.elements[i];
      const card = element.querySelector('.card');
      let elementDelay = 0;
      if (element.dataset.delay) {
        elementDelay = element.dataset.delay / 1000;
      }

      gsap.from(card, {
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
        opacity: 0,
        y: 100,
        duration: 0.5,
        delay: elementDelay,
      });
    }
  }
}
